export default __webpack_public_path__ + "images/mm-6f93c6d0ec04077b61c7c7f0f97f0332.svg";